const duration = 0.7;

const transition = {
	duration,
	type: 'tween',
	ease: 'easeOut',
};

export { duration, transition };
